import React from 'react';

const Sandbox: React.FC = () => null;

export default Sandbox;
